import { createSlice } from "@reduxjs/toolkit";

export const contactFormSlice = createSlice({
    name: "contactForm",
    initialState: {
        contactName: "",
        email: "",
        projectType: { value: "inscriptionOrDesign", label: "Inscription or Design"},
        budget: { value: "Under $100", label: "Under $100"},
        projectDetails: "",
        formStatus: 'pending'
    },
    reducers: {
        setContactName: (state, action) => {
            return {
                ...state,
                contactName: action.payload
            }
        },
        setContactEmail: (state, action) => {
            return {
                ...state,
                email: action.payload
            }
        },
        setContactProjectType: (state, action) => {
            return {
                ...state,
                projectType: action.payload
            }
        },
        setContactBudget: (state, action) => {
            return {
                ...state,
                budget: action.payload
            }
        },
        setContactProjectDetails: (state, action) => {
            return {
                ...state,
                projectDetails: action.payload
            }
        },
        setFormStatus: (state, action) => {
            return {
                ...state,
                formStatus: action.payload
            }
        },
        clearContactForm: (state, action) => {
            return {
                ...state,
                contactName: "",
                email: "",
                projectType: { value: "inscriptionOrDesign", label: "Inscription or Design"},
                budget: { value: "Under $100", label: "Under $100"},
                projectDetails: ""
            }
        }
    }
})

export const selectContactName = (state) => state.contactForm.contactName;
export const selectContactEmail = (state) => state.contactForm.email;
export const selectContactProjectType = (state) => state.contactForm.projectType;
export const selectContactBudget = (state) => state.contactForm.budget;
export const selectContactProjectDetails = (state) => state.contactForm.projectDetails;
export const selectFormStatus = (state) => state.contactForm.formStatus;

export const {
    setContactName,
    setContactEmail,
    setContactProjectType,
    setContactBudget,
    setContactProjectDetails,
    setFormStatus,
    clearContactForm
} = contactFormSlice.actions;

export default contactFormSlice.reducer;